<template>
    <v-simple-table dense>
        <thead>
            <tr>
                <th>Customer</th>
                <th>Balance</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(d, i) in data" :key="i">
                <td>
                    <v-btn icon left @click="handleOpenCustomerCenter(d)">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <span>{{d.customer_code}} - {{d.customer_name}}</span>
                </td>
                <td>
                    <v-btn icon @click="handleStatement(d)">
                        <v-icon>mdi-text-box-outline</v-icon>
                    </v-btn>
                    <span class="font-weight-bold">{{baseCurrency.abbreviation}}</span>
                    {{formatNumber(d.balance)}}
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr class="secondary">
                <td></td>
                <td>
                    <span class="font-weight-bold">{{baseCurrency.abbreviation}}</span>
                    {{formatNumber(getTotal(data, "balance"))}}
                </td>
            </tr>
        </tfoot>
        <customer-display-dialog ref="customerDisplayDialog"> </customer-display-dialog>
    </v-simple-table>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { formatNumber } from 'accounting';
import { getTotal } from '../../utils/accounting';
import CustomerDisplayDialog from './../Sales/CustomerDisplayDialog';

export default {
    name: "CustomersBalanceReportTable",
    components: {
        CustomerDisplayDialog
    },
    computed: {
        ...mapGetters("sales/reports/customersBalance", [
            "data"
        ]),
        ...mapState("accounting", ["baseCurrency"])
    },
    methods: {
        getTotal,
        formatNumber(n) {
            return formatNumber(n, 2);
        },
        handleStatement(row) {
            this.$router.push({ name: "CustomerStatement", query: {
                customer_id: row.customer_id
            } })
        },
        handleOpenCustomerCenter(row) {
            this.$refs.customerDisplayDialog.open({ id: row.customer_id });
        }
    }
}
</script>

<style>

</style>